<template><router-view /></template>

<script>
export default {
  async mounted() {
    console.log("App mounted");
  },
};
</script>
